import React, { useEffect, useState } from 'react';
import { SecondaryButton } from '@gjensidige/core-buttons';
import { RaadgivningInput } from '@gjensidige/gpf-raadgivning-form';
import { FatcaQuestionKey } from '../../../../utils/types';
import { text } from '../../../../utils/text';
export const TaxRelationSection = ({ answers, questions, updateAnswer, control, editable, }) => {
    const [hasExtraTaxRelation, setHasExtraTaxRelation] = useState(false);
    useEffect(() => {
        if (hasOtherTaxRelationExtra(questions, answers)) {
            setHasExtraTaxRelation(true);
        }
    }, [questions, answers]);
    const taxRelationQuestions = questions.filter((question) => question.key === FatcaQuestionKey.VELG_SKATTEPLIKTIG_LAND || question.key === FatcaQuestionKey.SKATTENUMMER);
    const taxRelationQuestionsExtra = questions.filter((question) => question.key === FatcaQuestionKey.VELG_SKATTEPLIKTIG_LAND_2 || question.key === FatcaQuestionKey.SKATTENUMMER_2);
    const removeExtraTaxRelation = () => {
        setHasExtraTaxRelation(false);
        taxRelationQuestionsExtra.forEach((question) => {
            var _a;
            if (((_a = answers[question.id]) === null || _a === void 0 ? void 0 : _a.length) > 0)
                delete answers[question.id];
        });
    };
    if (hasExtraTaxRelation) {
        return (React.createElement(React.Fragment, null,
            [...taxRelationQuestions, ...taxRelationQuestionsExtra].map((question) => (React.createElement(RaadgivningInput, { key: question.id, question: question, answers: answers[question.id], updateAnswer: updateAnswer, editable: editable, control: control }))),
            editable && (React.createElement(SecondaryButton, { onClick: () => removeExtraTaxRelation(), noPadding: true }, text.FORM.TAX_FORM.REMOVE_TAX_RELATION.no))));
    }
    else {
        return (React.createElement(React.Fragment, null,
            taxRelationQuestions.map((question) => (React.createElement(RaadgivningInput, { key: question.id, question: question, answers: answers[question.id], updateAnswer: updateAnswer, editable: editable, control: control }))),
            editable && (React.createElement(SecondaryButton, { onClick: () => setHasExtraTaxRelation(true), noPadding: true }, text.FORM.TAX_FORM.ADD_TAX_RELATION.no))));
    }
};
export const hasOtherTaxRelation = (questions, answers) => {
    return shouldTriggerFollowUp(questions, answers, FatcaQuestionKey.SKATTEPLIKTIG_LAND);
};
export const hasOtherTaxRelationExtra = (questions, answers) => {
    return shouldTriggerFollowUp(questions, answers, FatcaQuestionKey.VELG_SKATTEPLIKTIG_LAND_2);
};
const shouldTriggerFollowUp = (questions, answers, key) => {
    var _a, _b;
    const question = questions.find((q) => q.key === key);
    const answerOptionsTriggeringFollowUp = question === null || question === void 0 ? void 0 : question.options.filter((opt) => !!opt.followUpQuestionId).map((it) => it.id);
    if (question === undefined || answerOptionsTriggeringFollowUp === undefined) {
        return false;
    }
    const answer = (_b = (_a = answers[question.id]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.optionId;
    return answerOptionsTriggeringFollowUp.some((opt) => opt.toString() === answer);
};
